export const COOKING_IMAGE_URL = "/assets/cooking.gif";
export const DELIVERY_IMAGE_URL = "/assets/delivering.gif"
export const CONTACTING_IMAGE_URL = "/assets/contacting.gif";
export const WAITER_IMAGE_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/waiter.gif";
export const SECURE_PAYMENT_STRIPE_IMAGE_URL =
  "https://firebasestorage.googleapis.com/v0/b/lys1-e9cd8.appspot.com/o/webapp%2Fsecure-stripe-payment-logo.png?alt=media&token=cf33f2c9-39f1-4f30-98aa-bcbb92ef666e";
export const IMAGE_UNAVAILABLE_IMAGE_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/image_unavailable.png";
export const PAYMENT_IMAGE_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/payment.gif";
export const DRIVER_ICON_URL = "/assets/driver.png";
export const CUSTOMER_ICON_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/customer-gris.png";
export const SHOP_ICON_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/shop-gris.png";
export const CARD_ICON_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/card.png";
export const CLICK_AND_COLLECT_ICON_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/click-collect.png";
export const TIME_ICON_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/time.png";
export const PLAYSTORE_IMAGE_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/google-play.png";
export const APPLESTORE_IMAGE_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/app-store.png";
export const MOBILEAPP_IMAGE_URL =
  "https://dishop-asset-app.s3-eu-west-1.amazonaws.com/mobile-app.png";
 export const SEARCH_DRIVER_IMAGE_URL = "/assets/SandyLoading.gif"
  export const TAKEAWAY_IMAGE_URL = "/assets/takeAway.gif"
export const IMAGE_ASPECT_COVER = "cover";
